import { BaseDto } from "./base.dto";
import { StockDto } from './stock.dto';
import { StockLocationDto } from './stockLocation.dto';
import { StockUnitDto } from './stockUnit.dto';
import { StockVariancesDto } from "./stockVariances.dto";

export class StockVariancesDetailDto extends BaseDto{
    stockVariances?: StockVariancesDto;
    stockVariancesId: number;
    stockUnit?: StockUnitDto;
    stockUnitId: number;
    stock?: StockDto;
    stockId: number;
    stockLocation?: StockLocationDto;
    stockLocationId: number;
    quantity: number;
    outOfStock: boolean;
    caseQty: number;
    unitQty: number;
    splitQty: number;
    totalAMT: number;
    variances: number;
}
